import { HelpCenterRounded } from '@mui/icons-material'
import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

const HELP_URL = 'https://support.comstruct.com'

/**
 * A button that navigates to the help page when clicked.
 * @category Shared
 */
export function HelpButton(props: {
  size?: 'small' | 'medium' | 'large'
}): JSX.Element {
  const { t } = useTranslation()
  const { size } = props
  return (
    <Button
      component={Link}
      to={HELP_URL}
      target='_blank'
      color='inherit'
      size={size}
      variant='text'
      startIcon={<HelpCenterRounded />}
    >
      {t('help')}
    </Button>
  )
}
